export interface ScreenData {
  name: string;
  route: string;
  module: string;
}

export const WelcomeScreen: ScreenData = {
  name: '',
  route: 'welcome',
  module: 'default',
};

export const InventorySummaryScreen: ScreenData = {
  name: 'Inventory Summary',
  route: 'inventory/summary',
  module: 'inventory',
};

export const InventoryDetailScreen: ScreenData = {
  name: 'Inventory Item Detail',
  route: 'inventory/detail',
  module: 'inventory',
};

export const InventoryLotScreen: ScreenData = {
  name: 'Inventory Lot Detail',
  route: 'inventory/lot',
  module: 'inventory',
};

export const OrderCreateInboundHeaderScreen: ScreenData = {
  name: 'Create Inbound Order',
  route: 'orders/create/inbound/header',
  module: 'ib_order_create',
};

export const OrderCreateOutboundHeaderScreen: ScreenData = {
  name: 'Create Outbound Order',
  route: 'orders/create/outbound/header',
  module: 'ob_order_create',
};

export const OrderInquiryScreen: ScreenData = {
  name: 'Order Summary',
  route: 'orders/inquiry',
  module: 'order',
};

export const OrderDetailsScreen: ScreenData = {
  name: 'Order Details',
  route: 'orders/detail',
  module: 'order',
};

export const ReportListScreen: ScreenData = {
  name: 'Report List',
  route: 'reports/list',
  module: 'run_report',
};

export const RunReportsScreen: ScreenData = {
  name: 'Generate Report',
  route: 'reports/generate',
  module: 'run_report',
};

export const UserLookupScreen: ScreenData = {
  name: 'User Lookup',
  route: 'admin/user-lookup',
  module: 'user_maintenance',
};

export const UserCreateScreen: ScreenData = {
  name: 'User Create',
  route: 'admin/user-create',
  module: 'user_create',
};

export const UserImageUploadScreen: ScreenData = {
  name: 'Image Upload',
  route: 'admin/user-image-upload',
  module: 'user_image_upload',
};

export const RefreshReportsScreen: ScreenData = {
  name: 'Refresh Reports',
  route: 'admin/refresh-reports',
  module: 'refresh_reports',
};
